<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100 h-100 pb-3" style="overflow-x: hidden">
        <navbar :title="$t('menu.accounts')" class="mb-1"/>
        <div class="col-sm-12 nopads">
            <account-search
                class="my-2"
                :user="user"
                @search="searchWithParams"/>

            <div class="col-12 d-flex justify-content-end">
                <button class="form-button btn btn-success" @click="addItem">
                    {{ $t('common.add_new') }}
                </button>
            </div>
            <account-list
                class="my-2"
                :results="results"
                @rowClicked="editItem"/>
            <base-modal v-if="editMode" hide-header hide-footer @close="showList" size="lg">
                <account-editor
                    :account="result"
                    :is-super-user="isSuperUser"
                    @closeAndUpdate="searchWithParams"
                    @close="showList"
                />
            </base-modal>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";
import AccountSearch from "@/components/account/AccountSearch.vue";
import AccountList from "@/components/account/AccountList.vue";
import AccountEditor from "@/components/account/AccountEditor.vue";

export default {
    name: 'accounts',
    components: {
        AccountList,
        AccountSearch, BaseModal, Navbar, AccountEditor},
    mixins: [restApi, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        isSuperUser: Boolean,
    },
    data: function () {
        return {
            loading: false,
            searchParams: null,
            editMode: false,
            results: [],
            result: null
        }
    },
    methods: {
        searchWithParams: function (params) {
            this.results = []
            this.loading = true
            this.searchParams = params || []
            this.restFetchParams(this.accountUrl, params, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
            this.showList()
        },
        showList: function () {
            this.editMode = false
        },
        editItem: function (item) {
            this.result = item
            this.editMode = true
        },
        addItem: function () {
            this.result = null
            this.editMode = true
        }
    }
}
</script>
